function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Message, MessageBox, Alert, Notification } from 'element-ui';
var msgTips = /*#__PURE__*/function () {
  function msgTips() {
    _classCallCheck(this, msgTips);
  }
  return _createClass(msgTips, [{
    key: "msg",
    value:
    // 消息提示
    function msg(_msg) {
      Message.info({
        message: _msg,
        duration: 5000
      });
    }

    // 错误消息
  }, {
    key: "msgError",
    value: function msgError(msg) {
      Message.error({
        message: msg,
        duration: 5000
      });
    }

    // 成功消息
  }, {
    key: "msgSuccess",
    value: function msgSuccess(msg) {
      Message.success({
        message: msg,
        duration: 5000
      });
    }

    // 警告消息
  }, {
    key: "msgWarning",
    value: function msgWarning(msg) {
      Message.warning({
        message: msg,
        duration: 5000
      });
    }

    // 弹出提示
  }, {
    key: "alert",
    value: function alert(msg) {
      Alert(msg, '系统提示');
    }

    // 通知提示
  }, {
    key: "notify",
    value: function notify(msg) {
      Notification.info(msg);
    }

    // 错误通知
  }, {
    key: "notifyError",
    value: function notifyError(msg) {
      Notification.error(msg);
    }

    // 成功通知
  }, {
    key: "notifySuccess",
    value: function notifySuccess(msg) {
      Notification.success(msg);
    }

    // 警告通知
  }, {
    key: "notifyWarning",
    value: function notifyWarning(msg) {
      Notification.warning(msg);
    }

    // 确认窗体
  }, {
    key: "confirm",
    value: function confirm(options) {
      return new Promise(function (resolve, reject) {
        MessageBox.confirm(options.message, options.title || '温馨提示', {
          confirmButtonText: options.confirmButtonText || '确定',
          confirmButtonClass: options.confirmButtonClass || '',
          cancelButtonText: options.cancelButtonText || '取消',
          cancelButtonClass: options.cancelButtonClass || '',
          type: options.type || 'warning'
        }).then(function () {
          resolve();
        }).catch(function () {
          console.log(options.cancelButtonText || '取消');
        });
      });
    }

    // 提交内容
    // prompt(content: string, title: string, options?: ElMessageBoxOptions) {
    //   return this.$prompt(content, title, {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     ...options
    //   })
    // }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      return new msgTips();
    }
  }]);
}();
var Tips = msgTips.getInstance();
export default Tips;